import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { convertQuote } from "../QuoteService";
import { RenderPage } from "../../../../slices/common/reducer";
import { showToast } from "../../../../common/Toaster/Toaster";

const useConvertQuote = () => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: convertQuote,
    onSuccess: () => {
      showToast("Quote converted successfully", "success");
      dispatch(RenderPage());
    },
    onError: (error) => {
      showToast(
        error?.response?.data?.error_message || "Error while converting quote",
        "error"
      );
    },
  });
};

export default useConvertQuote;
